<template>
  <div class="jl-breadcrumb">
    <ul class="jl-breadcrumb-list">
      <li class="item" v-for="(item, index) in breadData" :key="item.path">
        <a
          v-if="index < breadData.length - 1"
          @click.prevent="gotolink(item,index)"
        >{{item.meta.title}}&nbsp;>&nbsp;</a>
        <a class="active" v-else>{{item.meta.title}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadData: []
    };
  },
  watch: {
    $route() {
      this.getPath();
    }
  },
  created() {
    this.getPath();
  },
  methods: {
    getPath() {
      let arr = this.$route.matched;
      this.breadData = arr.filter((item, index) => {
        if (item.meta && item.meta.title) {
          return item;
        }
      });
    },
    gotolink(item, index) {
      let data = {
        path: item.path
      };
      if (index === 1) {
        data.query = this.$route.query;
      }
      this.$router.push(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-breadcrumb {
  padding: 14px 0;
}
.jl-breadcrumb-list {
  .item {
    display: inline-block;
    vertical-align: middle;
    > a {
      font-size: 14px;
      color: #8b8b8b;
      &.active {
        color: #e50011;
      }
    }
  }
}
</style>
